import { styled, SxProps, Box } from '@mui/material';
import { combineSX } from '@/utils/combineSX';
import React from 'react';
import { Img } from '@/components/blocks/MaterialImage';

const Video = styled('video')(() => ({
	width: '100%',
	height: '420px',
}));

export const DpVideoWithBackground = ({
	sxvideo,
	source,
	backgroundimage = '',
}: {
	sxvideo?: SxProps;
	source: string;
	backgroundimage?: string;
}) => (
	<Box
		sx={{
			width: '100vw',
			height: '420px',
			position: 'relative',
		}}
	>
		<Img
			sx={{
				position: 'absolute',
				width: '100%',
				height: '100%',
				objectFit: 'cover',
				zIndex: '-20',
			}}
			src={backgroundimage}
		/>
		<Video
			src={source}
			loop
			controls
			muted
			sx={combineSX([...(Array.isArray(sxvideo) ? sxvideo : [sxvideo])])}
		></Video>
	</Box>
);
